import menuTitleReducer from './menu-title-reducer'

export default menuTitleReducer
